import { Inject, Pipe } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { PipeTransform } from '@angular/core';

/**
 * Displays default content when string input is empty
 *
 * @param {string} amount Input to filter.
 * @param {object=} params  Filter configuration object
 * @param {string=} params.defaultValue  - Default content to be used
 *
 * @returns {string} with default content if input is empty
 *
 * @example
 *
 * Basic Example:
 * {{ binding | tdWbPlaceholder } }} - when binding is '' output is 'N/A'
 * Custom Example:
 * {{ binding | tdWbPlaceholder : { 'defaultValue': '-' } }} - when binding is '' output is '-'
 */
@Pipe({
  name: 'tdWbPlaceholder'
})
export class PlaceholderPipe implements PipeTransform {

  constructor(@Inject(TranslateService) private translateService: TranslateService) {
  }

  transform(value: string | number, params?: { defaultValue: string }): string | number {
    if (typeof value === 'string' && value.length === 0 || value === null || value === undefined) {
      let defaultContent = this.translateService.instant('tdWb.core.pipes.NA');

      if (params !== undefined && params.defaultValue !== undefined) {
        defaultContent = params.defaultValue;
      }
      return defaultContent;
    }
    return value;
  }

}
